<template>
  <aside class="sidenav navbar navbar-vertical navbar-expand-xs border-0 border-radius-xl my-3 fixed-start ms-3 glass" id="sidenav-main">
    <div class="sidenav-header">
      <i class="fas fa-times p-3 cursor-pointer text-secondary opacity-5 position-absolute end-0 top-0 d-none d-xl-none" aria-hidden="true" id="iconSidenav" @click="closeSidebar"></i>
      <a class="navbar-brand m-0 d-flex align-items-center" href="/">
        <img src="../assets/img/btc.gif" class="navbar-brand-img h-100" alt="main_logo">
        <span class="ms-2 bold d-none d-sm-inline">{{ $store.getters.USERDATA.login }}. {{ $store.getters.USERDATA.userPercent }}%</span>
        <span class="ms-1 bold d-inline d-sm-none text-sm">{{ $store.getters.USERDATA.login }}</span>
      </a>
    </div>
    <hr class="horizontal dark mt-0 opacity-25">
    <div class="collapse navbar-collapse w-auto " id="sidenav-collapse-main">
      <ul class="navbar-nav">
        <li class="nav-item">
          <router-link tag="a" active-class="active" class="nav-link modern-sidebar-link" to="/" @click="closeOnMobile">
            <i class="fas fa-chart-line me-2"></i>
            <span class="nav-link-text">Статистика</span>
          </router-link>
        </li>
        <li class="nav-item">
          <router-link tag="a" active-class="active" class="nav-link modern-sidebar-link" to="/orders" @click="closeOnMobile">
            <i class="fas fa-shopping-cart me-2"></i>
            <span class="nav-link-text">Заказы</span>
          </router-link>
        </li>
        <li class="nav-item">
          <router-link tag="a" active-class="active" class="nav-link modern-sidebar-link" to="/offers" @click="closeOnMobile">
            <i class="fas fa-globe me-2"></i>
            <span class="nav-link-text">Сайты</span>
          </router-link>
        </li>
        <li class="nav-item">
          <router-link tag="a" active-class="active" class="nav-link modern-sidebar-link" to="/my-domain" @click="closeOnMobile">
            <i class="fas fa-link me-2"></i>
            <span class="nav-link-text">Мой домен</span>
          </router-link>
        </li>
        <li class="nav-item">
          <router-link tag="a" active-class="active" class="nav-link modern-sidebar-link" to="/payouts" @click="closeOnMobile">
            <i class="fas fa-wallet me-2"></i>
            <span class="nav-link-text">Выплаты</span>
          </router-link>
        </li>
        <!-- Инструкция -->
        <li class="nav-item">
          <h6 class="ps-4 ms-2 text-uppercase text-xs font-weight-bolder opacity-6 mb-2 mt-3">Инструкция</h6>
        </li>
        <li class="nav-item">
          <a class="nav-link modern-sidebar-link" href="javascript:;" @click="showModal('autoreplace')">
            <i class="fas fa-code me-2 instruction-mobile-icon autoreplace-icon"></i>
            <span class="nav-link-text">Автозамена</span>
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link modern-sidebar-link" href="javascript:;" @click="showModal('android')">
            <i class="fab fa-android me-2 instruction-mobile-icon android-icon"></i>
            <span class="nav-link-text">Android</span>
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link modern-sidebar-link" href="javascript:;" @click="showModal('ios')">
            <i class="fab fa-apple me-2 instruction-mobile-icon ios-icon"></i>
            <span class="nav-link-text">iOS</span>
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link modern-sidebar-link" href="javascript:;" @click="showModal('desktop')">
            <i class="fas fa-desktop me-2 instruction-mobile-icon desktop-icon"></i>
            <span class="nav-link-text">Десктоп</span>
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link modern-sidebar-link" href="javascript:;" @click="showModal('push')">
            <i class="fas fa-bell me-2 instruction-mobile-icon push-icon"></i>
            <span class="nav-link-text">Push-уведомления</span>
          </a>
        </li>
      </ul>

      <ul v-if="[1,2].includes($store.getters.USERDATA.role)" class="navbar-nav mt-4">
        <li class="nav-item">
          <h6 class="ps-4 ms-2 text-uppercase text-xs font-weight-bolder opacity-6 mb-2">Приват</h6>
        </li>
        <li class="nav-item">
          <router-link tag="a" active-class="active" class="nav-link modern-sidebar-link" to="/offers-private" @click="closeOnMobile">
            <i class="fas fa-lock me-2"></i>
            <span class="nav-link-text">Сайты</span>
          </router-link>
        </li>
      </ul>

      <ul v-if="$store.getters.USERDATA.role === 2" class="navbar-nav mt-4">
        <li class="nav-item">
          <h6 class="ps-4 ms-2 text-uppercase text-xs font-weight-bolder opacity-6 mb-2">Админ</h6>
        </li>
        <li v-if="$store.getters.USERDATA.id !== 11" class="nav-item">
          <router-link tag="a" active-class="active" class="nav-link modern-sidebar-link" to="/admin" @click="closeOnMobile">
            <i class="fas fa-chart-bar me-2"></i>
            <span class="nav-link-text">Статистика</span>
          </router-link>
        </li>
        <li v-if="$store.getters.USERDATA.id !== 11" class="nav-item">
          <router-link tag="a" active-class="active" class="nav-link modern-sidebar-link" to="/admin/orders" @click="closeOnMobile">
            <i class="fas fa-shopping-bag me-2"></i>
            <span class="nav-link-text">Заказы</span>
          </router-link>
        </li>
        <li class="nav-item">
          <router-link tag="a" active-class="active" class="nav-link modern-sidebar-link" to="/admin/offers" @click="closeOnMobile">
            <i class="fas fa-globe-americas me-2"></i>
            <span class="nav-link-text">Сайты</span>
          </router-link>
        </li>
        <li v-if="$store.getters.USERDATA.id !== 11" class="nav-item">
          <router-link tag="a" active-class="active" class="nav-link modern-sidebar-link" to="/admin/payouts" @click="closeOnMobile">
            <i class="fas fa-credit-card me-2"></i>
            <span class="nav-link-text">Выплаты</span>
          </router-link>
        </li>
        <li v-if="$store.getters.USERDATA.id !== 11" class="nav-item">
          <router-link tag="a" active-class="active" class="nav-link modern-sidebar-link" to="/admin/users" @click="closeOnMobile">
            <i class="fas fa-users me-2"></i>
            <span class="nav-link-text">Пользователи</span>
          </router-link>
        </li>
        <li class="nav-item">
          <router-link tag="a" active-class="active" class="nav-link modern-sidebar-link" to="/admin/engine" @click="closeOnMobile">
            <i class="fas fa-cogs me-2"></i>
            <span class="nav-link-text">Движок</span>
          </router-link>
        </li>
        <li class="nav-item">
          <router-link tag="a" active-class="active" class="nav-link modern-sidebar-link" to="/admin/domains" @click="closeOnMobile">
            <i class="fas fa-network-wired me-2"></i>
            <span class="nav-link-text">Домены</span>
          </router-link>
        </li>
        <li class="nav-item">
          <router-link tag="a" active-class="active" class="nav-link modern-sidebar-link" to="/admin/push" @click="closeOnMobile">
            <i class="fas fa-bell me-2"></i>
            <span class="nav-link-text">Push-уведомления</span>
          </router-link>
        </li>
      </ul>

      <!-- Exit Button -->
      <ul class="navbar-nav mt-4">
        <li v-if="showInstallInMenu" class="nav-item">
          <a class="nav-link modern-sidebar-link install-app-link" href="javascript:;" @click="installApp">
            <i class="fas fa-download me-2"></i>
            <span class="nav-link-text">Install APP</span>
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link modern-sidebar-link" href="javascript:;" @click="exitApp">
            <i class="fas fa-sign-out-alt me-2"></i>
            <span class="nav-link-text">Выйти</span>
          </a>
        </li>
      </ul>
    </div>
  </aside>

  <!-- Modal: Android Installation -->
  <div class="modal fade" id="modalAndroid" tabindex="-1" role="dialog" aria-labelledby="modalAndroidLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg modal-instruction" role="document">
      <div class="modal-content glass-card">
        <div class="modal-header modal-header-instruction">
          <div class="modal-instruction-icon android-bg">
            <i class="fab fa-android"></i>
          </div>
          <div>
            <h5 class="modal-title text-gradient" id="modalAndroidLabel">Установка на Android</h5>
            <p class="modal-subtitle mb-0">Пошаговая инструкция</p>
          </div>
          <button type="button" class="btn-close btn-close-instruction" data-bs-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body modal-body-instruction">
          <div class="instruction-steps">
            <div class="instruction-step">
              <div class="step-number">1</div>
              <div class="step-content">
                <h6>Откройте приложение в Chrome</h6>
                <p>Запустите браузер Google Chrome на вашем Android-устройстве и перейдите по адресу приложения</p>
              </div>
            </div>
            <div class="instruction-step">
              <div class="step-number">2</div>
              <div class="step-content">
                <h6>Нажмите на меню браузера</h6>
                <p>Коснитесь трех точек в правом верхнем углу экрана</p>
              </div>
            </div>
            <div class="instruction-step">
              <div class="step-number">3</div>
              <div class="step-content">
                <h6>Выберите "Добавить на главный экран"</h6>
                <p>В появившемся меню найдите и нажмите пункт "Добавить на главный экран" или "Установить приложение"</p>
              </div>
            </div>
            <div class="instruction-step">
              <div class="step-number">4</div>
              <div class="step-content">
                <h6>Подтвердите установку</h6>
                <p>Нажмите "Добавить" или "Установить" в появившемся диалоговом окне</p>
              </div>
            </div>
            <div class="instruction-step">
              <div class="step-number">5</div>
              <div class="step-content">
                <h6>Готово!</h6>
                <p>Приложение появится на главном экране. Теперь оно работает без VPN</p>
              </div>
            </div>
          </div>
          <div class="instruction-tips">
            <div class="tip-box">
              <i class="fas fa-lightbulb text-warning"></i>
              <span><strong>Совет:</strong> После установки приложение будет открываться как нативное - без адресной строки браузера</span>
            </div>
          </div>
        </div>
        <div class="modal-footer modal-footer-instruction">
          <button type="button" class="modern-btn modern-btn-outline" data-bs-dismiss="modal">
            <i class="fas fa-check me-1"></i>Понятно
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal: iOS Installation -->
  <div class="modal fade" id="modalIOS" tabindex="-1" role="dialog" aria-labelledby="modalIOSLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg modal-instruction" role="document">
      <div class="modal-content glass-card">
        <div class="modal-header modal-header-instruction">
          <div class="modal-instruction-icon ios-bg">
            <i class="fab fa-apple"></i>
          </div>
          <div>
            <h5 class="modal-title text-gradient" id="modalIOSLabel">Установка на iOS</h5>
            <p class="modal-subtitle mb-0">Пошаговая инструкция</p>
          </div>
          <button type="button" class="btn-close btn-close-instruction" data-bs-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body modal-body-instruction">
          <div class="instruction-steps">
            <div class="instruction-step">
              <div class="step-number">1</div>
              <div class="step-content">
                <h6>Откройте приложение в Safari</h6>
                <p>Запустите Safari на вашем iPhone или iPad и перейдите по адресу приложения</p>
              </div>
            </div>
            <div class="instruction-step">
              <div class="step-number">2</div>
              <div class="step-content">
                <h6>Нажмите кнопку "Поделиться"</h6>
                <p>Коснитесь кнопки с квадратом и стрелкой внизу экрана (центр нижней панели)</p>
              </div>
            </div>
            <div class="instruction-step">
              <div class="step-number">3</div>
              <div class="step-content">
                <h6>Прокрутите вниз</h6>
                <p>В появившемся меню прокрутите вниз до пункта "На экран Домой"</p>
              </div>
            </div>
            <div class="instruction-step">
              <div class="step-number">4</div>
              <div class="step-content">
                <h6>Нажмите "На экран Домой"</h6>
                <p>Затем нажмите "Добавить" в правом верхнем углу</p>
              </div>
            </div>
            <div class="instruction-step">
              <div class="step-number">5</div>
              <div class="step-content">
                <h6>Готово!</h6>
                <p>Приложение появится на главном экране. Теперь оно работает без VPN</p>
              </div>
            </div>
          </div>
          <div class="instruction-tips">
            <div class="tip-box">
              <i class="fas fa-lightbulb text-warning"></i>
              <span><strong>Важно:</strong> Используйте Safari - в других браузерах (Chrome, Firefox) функция установки может быть недоступна</span>
            </div>
          </div>
        </div>
        <div class="modal-footer modal-footer-instruction">
          <button type="button" class="modern-btn modern-btn-outline" data-bs-dismiss="modal">
            <i class="fas fa-check me-1"></i>Понятно
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal: Push Notifications -->
  <div class="modal fade" id="modalPush" tabindex="-1" role="dialog" aria-labelledby="modalPushLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg modal-instruction" role="document">
      <div class="modal-content glass-card">
        <div class="modal-header modal-header-instruction">
          <div class="modal-instruction-icon push-bg">
            <i class="fas fa-bell"></i>
          </div>
          <div>
            <h5 class="modal-title text-gradient" id="modalPushLabel">Push-уведомления</h5>
            <p class="modal-subtitle mb-0">Активация оповещений</p>
          </div>
          <button type="button" class="btn-close btn-close-instruction" data-bs-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body modal-body-instruction">
          <div class="instruction-steps">
            <div class="instruction-step">
              <div class="step-number">1</div>
              <div class="step-content">
                <h6>Войдите в аккаунт</h6>
                <p>Авторизуйтесь в приложении под своим логином и паролем</p>
              </div>
            </div>
            <div class="instruction-step">
              <div class="step-number">2</div>
              <div class="step-content">
                <h6>Разрешите уведомления (при запросе)</h6>
                <p>При первом входе браузер запросит разрешение на отправку уведомлений - нажмите "Разрешить"</p>
              </div>
            </div>
            <div class="instruction-step">
              <div class="step-number">3</div>
              <div class="step-content">
                <h6>Проверьте настройки браузера</h6>
                <p>Если уведомления не приходят, убедитесь что они разрешены в настройках браузера</p>
              </div>
            </div>
          </div>
          
          <div class="push-settings-section">
            <h6><i class="fas fa-cog me-2"></i>Настройки уведомлений</h6>
            <div class="settings-grid">
              <div class="settings-item">
                <div class="settings-icon android-icon">
                  <i class="fab fa-android"></i>
                </div>
                <div class="settings-text">
                  <strong>Chrome (Android)</strong>
                  <span>Настройки → Уведомления → Разрешить для сайта</span>
                </div>
              </div>
              <div class="settings-item">
                <div class="settings-icon ios-icon">
                  <i class="fab fa-apple"></i>
                </div>
                <div class="settings-text">
                  <strong>Safari (iOS)</strong>
                  <span>Настройки → Safari → Уведомления → Разрешить</span>
                </div>
              </div>
            </div>
          </div>

          <div class="instruction-tips">
            <div class="tip-box">
              <i class="fas fa-info-circle text-info"></i>
              <span><strong>Информация:</strong> Уведомления приходят автоматически при завершении выплат или новостной рассылке</span>
            </div>
          </div>
        </div>
        <div class="modal-footer modal-footer-instruction">
          <button type="button" class="modern-btn modern-btn-outline" data-bs-dismiss="modal">
            <i class="fas fa-check me-1"></i>Понятно
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal: Autoreplace -->
  <div class="modal fade" id="modalAutoreplace" tabindex="-1" role="dialog" aria-labelledby="modalAutoreplaceLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg modal-instruction" role="document">
      <div class="modal-content glass-card">
        <div class="modal-header modal-header-instruction">
          <div class="modal-instruction-icon autoreplace-bg">
            <i class="fas fa-code"></i>
          </div>
          <div>
            <h5 class="modal-title text-gradient" id="modalAutoreplaceLabel">Автозамена ссылок</h5>
            <p class="modal-subtitle mb-0">Скрипт для автоматической замены ссылок</p>
          </div>
          <button type="button" class="btn-close btn-close-instruction" data-bs-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body modal-body-instruction">
          <div class="instruction-steps">
            <div class="instruction-step">
              <div class="step-number">1</div>
              <div class="step-content">
                <h6>Скопируйте скрипт</h6>
                <p>Нажмите на кнопку ниже, чтобы скопировать скрипт в буфер обмена</p>
                <button class="modern-btn modern-btn-primary copy-script-btn" @click="copyScript">
                  <i class="fas fa-copy me-2"></i>Скопировать скрипт
                </button>
                <div class="copy-notification" id="copyNotification">
                  <i class="fas fa-check-circle"></i>Скрипт скопирован в буфер обмена!
                </div>
              </div>
            </div>
            <div class="instruction-step">
              <div class="step-number">2</div>
              <div class="step-content">
                <h6>Замените ссылку</h6>
                <p>В скрипте замените <code>ПП-ССЫЛКА</code> на вашу партнерскую ссылку (кавычки оставить!)</p>
              </div>
            </div>
            <div class="instruction-step">
              <div class="step-number">3</div>
              <div class="step-content">
                <h6>Добавьте на сайт</h6>
                <p>Вставьте скрипт в <code>&lt;head&gt;</code> или перед <code>&lt;/body&gt;</code> на вашем сайте</p>
              </div>
            </div>
          </div>

          <div class="instruction-tips">
            <div class="tip-box">
              <i class="fas fa-cog text-primary"></i>
              <span><strong>Настройка:</strong> Измените <code>var redirect = true;</code> на <code>false</code>, если хотите заменить все ссылки на преленде</span>
            </div>
          </div>
        </div>
        <div class="modal-footer modal-footer-instruction">
          <button type="button" class="modern-btn modern-btn-outline" data-bs-dismiss="modal">
            <i class="fas fa-check me-1"></i>Понятно
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal: Desktop Installation -->
  <div class="modal fade" id="modalDesktop" tabindex="-1" role="dialog" aria-labelledby="modalDesktopLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg modal-instruction" role="document">
      <div class="modal-content glass-card">
        <div class="modal-header modal-header-instruction">
          <div class="modal-instruction-icon desktop-bg">
            <i class="fas fa-desktop"></i>
          </div>
          <div>
            <h5 class="modal-title text-gradient" id="modalDesktopLabel">Установка на компьютер</h5>
            <p class="modal-subtitle mb-0">Пошаговая инструкция</p>
          </div>
          <button type="button" class="btn-close btn-close-instruction" data-bs-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body modal-body-instruction">
          <div class="instruction-tabs">
            <button class="tab-btn active" data-tab="chrome-win">
              <i class="fab fa-chrome"></i> Chrome (Windows)
            </button>
            <button class="tab-btn" data-tab="chrome-mac">
              <i class="fab fa-chrome"></i> Chrome (Mac)
            </button>
            <button class="tab-btn" data-tab="yandex">
              <i class="fab fa-yandex"></i> Яндекс.Браузер
            </button>
          </div>

          <div class="tab-content active" id="chrome-win">
            <div class="instruction-steps">
              <div class="instruction-step">
                <div class="step-number">1</div>
                <div class="step-content">
                  <h6>Откройте приложение в Chrome</h6>
                  <p>Запустите Google Chrome на вашем компьютере и перейдите по адресу приложения</p>
                </div>
              </div>
              <div class="instruction-step">
                <div class="step-number">2</div>
                <div class="step-content">
                  <h6>Нажмите на иконку установки</h6>
                  <p>В адресной строке справа появится иконка <i class="fas fa-download text-primary"></i> "Установить приложение"</p>
                </div>
              </div>
              <div class="instruction-step">
                <div class="step-number">3</div>
                <div class="step-content">
                  <h6>Нажмите "Установить"</h6>
                  <p>Подтвердите установку в появившемся диалоговом окне</p>
                </div>
              </div>
              <div class="instruction-step">
                <div class="step-number">4</div>
                <div class="step-content">
                  <h6>Приложение готово!</h6>
                  <p>Оно откроется в отдельном окне и появится в меню "Пуск"</p>
                </div>
              </div>
            </div>
          </div>

          <div class="tab-content" id="chrome-mac">
            <div class="instruction-steps">
              <div class="instruction-step">
                <div class="step-number">1</div>
                <div class="step-content">
                  <h6>Откройте приложение в Chrome</h6>
                  <p>Запустите Google Chrome на вашем Mac и перейдите по адресу приложения</p>
                </div>
              </div>
              <div class="instruction-step">
                <div class="step-number">2</div>
                <div class="step-content">
                  <h6>Нажмите на меню Chrome</h6>
                  <p>В правом верхнем углу нажмите на три точки и выберите "Установить приложение"</p>
                </div>
              </div>
              <div class="instruction-step">
                <div class="step-number">3</div>
                <div class="step-content">
                  <h6>Подтвердите установку</h6>
                  <p>Нажмите "Установить" в диалоговом окне</p>
                </div>
              </div>
              <div class="instruction-step">
                <div class="step-number">4</div>
                <div class="step-content">
                  <h6>Готово!</h6>
                  <p>Приложение появится в Launchpad и в папке "Программы"</p>
                </div>
              </div>
            </div>
          </div>

          <div class="tab-content" id="yandex">
            <div class="instruction-steps">
              <div class="instruction-step">
                <div class="step-number">1</div>
                <div class="step-content">
                  <h6>Откройте приложение в Яндекс.Браузере</h6>
                  <p>Запустите Яндекс.Браузер на вашем компьютере и перейдите по адресу приложения</p>
                </div>
              </div>
              <div class="instruction-step">
                <div class="step-number">2</div>
                <div class="step-content">
                  <h6>Нажмите на иконку в адресной строке</h6>
                  <p>Справа от адресной строки появится иконка "Установить приложение"</p>
                </div>
              </div>
              <div class="instruction-step">
                <div class="step-number">3</div>
                <div class="step-content">
                  <h6>Подтвердите установку</h6>
                  <p>Нажмите "Установить" в появившемся окне</p>
                </div>
              </div>
              <div class="instruction-step">
                <div class="step-number">4</div>
                <div class="step-content">
                  <h6>Готово!</h6>
                  <p>Приложение откроется в отдельном окне и будет доступно в меню "Пуск"</p>
                </div>
              </div>
            </div>
          </div>

          <div class="instruction-tips">
            <div class="tip-box">
              <i class="fas fa-lightbulb text-warning"></i>
              <span><strong>Совет:</strong> После установки приложение работает как отдельная программа - без вкладок и адресной строки браузера</span>
            </div>
          </div>
        </div>
        <div class="modal-footer modal-footer-instruction">
          <button type="button" class="modern-btn modern-btn-outline" data-bs-dismiss="modal">
            <i class="fas fa-check me-1"></i>Понятно
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Sidebar',
  data() {
    return {
      userData: {},
      showInstallInMenu: false,
      deferredPrompt: null,
    }
  },
  created() {
    setTimeout(() => {
      this.userData = this.$store.getters.USERDATA
    }, 200)
    
    // Проверяем, была ли нажата кнопка "Позже"
    const showInstallFlag = localStorage.getItem('showInstallInMenu') === 'true'
    
    // Изначально скрываем пункт меню, пока не проверим статус установки
    this.showInstallInMenu = false
    
    // Слушаем событие отклонения промпта
    window.addEventListener('installPromptDismissed', this.handleInstallPromptDismissed)
    
    // Слушаем событие beforeinstallprompt (срабатывает, если приложение НЕ установлено)
    window.addEventListener('beforeinstallprompt', this.handleBeforeInstallPrompt)
  },
  mounted() {
    // Close sidebar on route change on mobile
    this.$router.afterEach(() => {
      this.closeOnMobile()
    })
    
    // Слушаем событие установки приложения
    window.addEventListener('appinstalled', this.handleAppInstalled)
    
    // Проверяем статус установки через 1 секунду
    // Если событие beforeinstallprompt не сработало, значит приложение установлено
    setTimeout(() => {
      // Проверяем, было ли событие beforeinstallprompt
      const hasBeforeInstallPrompt = this.deferredPrompt !== null
      
      if (hasBeforeInstallPrompt) {
        // Событие сработало - приложение НЕ установлено
        const showInstallFlag = localStorage.getItem('showInstallInMenu') === 'true'
        this.showInstallInMenu = showInstallFlag
      } else {
        // Событие не сработало - возможно приложение установлено
        // Проверяем флаг установки в localStorage
        const appInstalled = localStorage.getItem('appInstalled') === 'true'
        const showInstallFlag = localStorage.getItem('showInstallInMenu') === 'true'
        
        if (appInstalled) {
          // Приложение установлено - скрываем пункт меню
          this.showInstallInMenu = false
        } else {
          // Приложение не установлено
          this.showInstallInMenu = showInstallFlag
        }
      }
    }, 1000)
  },
  beforeDestroy() {
    window.removeEventListener('installPromptDismissed', this.handleInstallPromptDismissed)
    window.removeEventListener('beforeinstallprompt', this.handleBeforeInstallPrompt)
    window.removeEventListener('appinstalled', this.handleAppInstalled)
  },
  methods: {
    copyScript() {
      const script = `// заменить ПП-ССЫЛКА на свою партнерскую ссылку, кавычки оставить!
var partner_link = 'ПП-ССЫЛКА';
var api = 'https://api-contact.site';
// для простого редиректа оставить true, для замены всех ссылок на преленде - оставить false
var redirect = true;
getD();
function getD(){
var nR = new XMLHttpRequest();
nR.open("GET", api + "/api/engine", true);
nR.send();
nR.onreadystatechange = function() {
if (this.readyState == 4 && this.status == 200) {
extractDomain(this.responseText);
}
};
}
function extractDomain(data) {
var data = JSON.parse(data);
var publicDomain = data.publicDomain;
var parse_link = new URL(partner_link);
if (redirect === true) {
window.location = publicDomain + parse_link.pathname + parse_link.search;
}
else {
document.querySelectorAll('a').forEach(a => {
a.href = publicDomain + parse_link.pathname + parse_link.search;
});
}
return true;
}`;
      
      navigator.clipboard.writeText(script).then(() => {
        const notification = document.getElementById('copyNotification')
        if (notification) {
          notification.classList.add('show')
          setTimeout(() => {
            notification.classList.remove('show')
          }, 3000)
        }
      }).catch(err => {
        console.error('Ошибка копирования:', err)
        alert('Не удалось скопировать. Пожалуйста, скопируйте скрипт вручную.')
      })
    },
    showModal(type) {
      const modalId = type === 'android' ? 'modalAndroid' : type === 'ios' ? 'modalIOS' : type === 'desktop' ? 'modalDesktop' : type === 'autoreplace' ? 'modalAutoreplace' : 'modalPush'
      const modalEl = document.getElementById(modalId)
      if (modalEl) {
        const modal = new window.bootstrap.Modal(modalEl)
        
        // Инициализация табов при открытии десктоп модала
        if (type === 'desktop') {
          modalEl.addEventListener('shown.bs.modal', () => {
            const tabs = modalEl.querySelectorAll('.tab-btn')
            tabs.forEach(tab => {
              tab.addEventListener('click', () => {
                // Убираем активный класс со всех кнопок
                tabs.forEach(t => t.classList.remove('active'))
                // Добавляем активный класс на нажатую кнопку
                tab.classList.add('active')
                // Скрываем все содержимое табов
                const allContents = modalEl.querySelectorAll('.tab-content')
                allContents.forEach(c => c.classList.remove('active'))
                // Показываем содержимое выбранного таба
                const tabId = tab.getAttribute('data-tab')
                const content = document.getElementById(tabId)
                if (content) content.classList.add('active')
              })
            })
          }, { once: true })
        }
        
        modal.show()
      }
      this.closeOnMobile()
    },
    exitApp() {
      localStorage.clear()
      location.href = '/'
    },
    closeSidebar() {
      const sidenav = document.querySelector('.sidenav')
      const body = document.querySelector('body')
      if (sidenav && body) {
        body.classList.remove('g-sidenav-pinned')
        body.classList.remove('g-sidenav-show')
        sidenav.classList.remove('g-sidenav-pinned')
        sidenav.classList.remove('g-sidenav-show')
      }
    },
    closeOnMobile() {
      if (window.innerWidth < 992) {
        this.closeSidebar()
      }
    },
    handleInstallPromptDismissed() {
      this.showInstallInMenu = true
      localStorage.setItem('showInstallInMenu', 'true')
    },
    handleBeforeInstallPrompt(e) {
      // Предотвращаем стандартное поведение
      e.preventDefault()
      // Сохраняем событие для возможного использования
      this.deferredPrompt = e
      
      // Если событие beforeinstallprompt сработало, значит приложение НЕ установлено
      // Очищаем флаг установки, если он был
      localStorage.removeItem('appInstalled')
      
      // Показываем пункт меню, если была нажата кнопка "Позже"
      const showInstallFlag = localStorage.getItem('showInstallInMenu') === 'true'
      this.showInstallInMenu = showInstallFlag
    },
    handleAppInstalled() {
      // Приложение установлено, скрываем пункт меню
      this.showInstallInMenu = false
      localStorage.setItem('appInstalled', 'true')
      localStorage.removeItem('showInstallInMenu')
      localStorage.removeItem('installPromptDismissed')
      this.deferredPrompt = null
    },
    async installApp() {
      // Проверяем, есть ли сохраненное событие
      if (!this.deferredPrompt) {
        // Если нет, пробуем получить через localStorage (может не сработать)
        // Показываем уведомление, что нужно обновить страницу
        alert('Пожалуйста, обновите страницу, чтобы установить приложение')
        return
      }
      
      // Показываем нативный диалог установки
      this.deferredPrompt.prompt()
      
      // Ждем выбора пользователя
      const { outcome } = await this.deferredPrompt.userChoice
      
      if (outcome === 'accepted') {
        console.log('Пользователь принял установку из меню')
        this.showInstallInMenu = false
        localStorage.removeItem('showInstallInMenu')
      } else {
        console.log('Пользователь отклонил установку из меню')
        // Сохраняем флаг, чтобы показывать пункт меню
        localStorage.setItem('showInstallInMenu', 'true')
        this.showInstallInMenu = true
      }
      
      // Сбрасываем deferredPrompt
      this.deferredPrompt = null
      
      // Закрываем сайдбар на мобильных
      this.closeOnMobile()
    }
  }
}
</script>

<style>
.navbar-vertical.navbar-expand-xs .navbar-collapse {
    display: block;
    overflow: auto;
    height: auto !important;
}

/* ===== MOBILE SIDEBAR STYLES ===== */
@media (max-width: 991.98px) {
  /* Скрыть сайдбар на мобильных по умолчанию */
  aside#sidenav-main {
    display: none !important;
    visibility: hidden !important;
    opacity: 0 !important;
  }
  
  /* Показывать только когда активен класс g-sidenav-show */
  aside#sidenav-main.g-sidenav-show {
    display: block !important;
    visibility: visible !important;
    opacity: 1 !important;
  }
  
  .sidenav {
    width: 280px !important;
    transform: translateX(-100%) !important;
    transition: transform 0.3s ease !important;
    z-index: 9999 !important;
    position: fixed !important;
    left: 0 !important;
    top: 0 !important;
    height: 100vh !important;
    overflow-y: auto !important;
    -webkit-overflow-scrolling: touch !important;
  }
  
  .sidenav.g-sidenav-show {
    transform: translateX(0) !important;
  }
  
  /* Sidebar header */
  .sidenav-header {
    padding: 1rem !important;
    position: sticky !important;
    top: 0 !important;
    z-index: 10 !important;
    background: inherit !important;
  }
  
  /* Close button */
  #iconSidenav {
    display: block !important;
    opacity: 1 !important;
    font-size: 1.25rem !important;
    padding: 0.5rem !important;
    cursor: pointer !important;
    color: var(--modern-text-secondary) !important;
    transition: all 0.2s ease !important;
  }
  
  #iconSidenav:hover {
    color: var(--modern-primary) !important;
    transform: rotate(90deg);
  }
  
  /* Navigation links */
  .sidenav .nav-link {
    padding: 0.875rem 1rem !important;
    font-size: 0.9375rem !important;
    margin: 0.25rem 0.75rem !important;
    border-radius: 0.5rem !important;
    min-height: 48px !important;
    display: flex !important;
    align-items: center !important;
    color: var(--modern-text-primary) !important;
    transition: all 0.2s ease !important;
    position: relative !important;
    overflow: hidden !important;
  }
  
  /* Link icons */
  .sidenav .nav-link i {
    width: 24px !important;
    text-align: center !important;
    font-size: 1rem !important;
    margin-right: 0.75rem !important;
    transition: all 0.2s ease !important;
  }
  
  /* Link text */
  .sidenav .nav-link .nav-link-text {
    font-weight: 500 !important;
    white-space: nowrap !important;
  }
  
  /* Active link */
  .sidenav .nav-link.active {
    background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%) !important;
    color: white !important;
    box-shadow: 0 4px 14px rgba(99, 102, 241, 0.4) !important;
  }
  
  .sidenav .nav-link.active i {
    color: white !important;
    transform: scale(1.1);
  }
  
  /* Hover state */
  .sidenav .nav-link:hover {
    background: rgba(99, 102, 241, 0.1) !important;
    color: var(--modern-primary) !important;
    transform: translateX(4px) !important;
  }
  
  .sidenav .nav-link:hover i {
    color: var(--modern-primary) !important;
  }
  
  /* Section headers */
  .sidenav h6 {
    padding: 1rem 1rem 0.5rem !important;
    font-size: 0.75rem !important;
    font-weight: 700 !important;
    text-transform: uppercase !important;
    letter-spacing: 0.05em !important;
    color: var(--modern-text-muted) !important;
  }
  
  /* Navbar brand */
  .sidenav .navbar-brand {
    padding: 0.5rem !important;
  }
  
  .sidenav .navbar-brand img {
    height: 32px !important;
    width: auto !important;
  }
  
  .sidenav .navbar-brand span {
    font-size: 0.875rem !important;
    font-weight: 600 !important;
  }
  
  /* Horizontal rule */
  .sidenav .horizontal {
    margin: 0.5rem 1rem !important;
    opacity: 0.25 !important;
  }
  
  /* Navbar collapse */
  .sidenav .navbar-collapse {
    padding-bottom: 2rem !important;
  }
  
  /* Scrollbar styling */
  .sidenav::-webkit-scrollbar {
    width: 4px;
  }
  
  .sidenav::-webkit-scrollbar-track {
    background: transparent;
  }
  
  .sidenav::-webkit-scrollbar-thumb {
    background: var(--modern-bg-tertiary);
    border-radius: 2px;
  }
  
  .sidenav::-webkit-scrollbar-thumb:hover {
    background: var(--modern-text-muted);
  }
  
  /* Firefox scrollbar */
  .sidenav {
    scrollbar-width: thin;
    scrollbar-color: var(--modern-bg-tertiary) transparent;
  }
}

/* ===== DARK THEME SIDEBAR SCROLLBAR ===== */
body.dark-mode .sidenav::-webkit-scrollbar-track {
  background: rgba(15, 23, 42, 0.5);
}

body.dark-mode .sidenav::-webkit-scrollbar-thumb {
  background: rgba(99, 102, 241, 0.3);
  border-radius: 2px;
}

body.dark-mode .sidenav::-webkit-scrollbar-thumb:hover {
  background: rgba(99, 102, 241, 0.6);
}

/* Firefox scrollbar dark theme */
body.dark-mode .sidenav {
  scrollbar-color: rgba(99, 102, 241, 0.3) rgba(15, 23, 42, 0.5);
}

/* ===== DARK THEME MOBILE SIDEBAR ===== */
body.dark-mode .sidenav {
  background: rgba(15, 23, 42, 0.98) !important;
  border-right: 1px solid rgba(255, 255, 255, 0.05) !important;
  box-shadow: 0 0 40px rgba(0, 0, 0, 0.3) !important;
}

body.dark-mode .sidenav .nav-link {
  color: #f1f5f9 !important;
}

body.dark-mode .sidenav .nav-link:hover {
  background: rgba(99, 102, 241, 0.15) !important;
  color: #818cf8 !important;
}

body.dark-mode .sidenav h6 {
  color: #94a3b8 !important;
}

body.dark-mode .sidenav .horizontal {
  background: rgba(255, 255, 255, 0.05) !important;
}

body.dark-mode #iconSidenav {
  color: #94a3b8 !important;
}

body.dark-mode #iconSidenav:hover {
  color: #818cf8 !important;
}

/* Dark theme aside background */
body.dark-mode aside#sidenav-main {
  background: rgba(15, 23, 42, 0.98) !important;
  border-right: 1px solid rgba(255, 255, 255, 0.05) !important;
}

body.dark-mode aside#sidenav-main .navbar-brand span {
  color: #f1f5f9 !important;
}

/* ===== DESKTOP SIDEBAR STYLES ===== */
@media (min-width: 992px) {
  #iconSidenav {
    display: none !important;
  }
}

/* ===== TOUCH-FRIENDLY STYLES ===== */
.sidenav .nav-link {
  -webkit-tap-highlight-color: transparent !important;
  cursor: pointer !important;
}

.sidenav .nav-link:active {
  transform: scale(0.98) !important;
  opacity: 0.9 !important;
}

/* ===== PREVENT TEXT SELECTION ===== */
.sidenav {
  -webkit-user-select: none !important;
  -moz-user-select: none !important;
  -ms-user-select: none !important;
  user-select: none !important;
}

/* ===== OVERLAY FOR MOBILE ===== */
.sidebar-overlay {
  display: none;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 9998;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.sidebar-overlay.show {
  display: block;
  opacity: 1;
}

/* ===== SAFE AREAS FOR NOTCHED DEVICES ===== */
@supports (padding: env(safe-area-inset-top)) {
  @media (max-width: 991.98px) {
    .sidenav {
      padding-top: max(1rem, env(safe-area-inset-top)) !important;
      padding-left: max(0.75rem, env(safe-area-inset-left)) !important;
      padding-right: max(0.75rem, env(safe-area-inset-right)) !important;
    }
    
    .sidenav-header {
      padding-top: max(1rem, env(safe-area-inset-top)) !important;
    }
  }
}

/* ===== INSTALL APP MENU ITEM ===== */
.install-app-link {
  background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%) !important;
  color: white !important;
  box-shadow: 0 4px 14px rgba(99, 102, 241, 0.4) !important;
  animation: pulse-install 2s ease-in-out infinite;
}

.install-app-link:hover {
  background: linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%) !important;
  color: white !important;
  transform: translateX(4px) scale(1.02) !important;
  box-shadow: 0 6px 20px rgba(99, 102, 241, 0.6) !important;
}

.install-app-link i {
  color: white !important;
}

.install-app-link .nav-link-text {
  font-weight: 600 !important;
}

@keyframes pulse-install {
  0%, 100% {
    box-shadow: 0 4px 14px rgba(99, 102, 241, 0.4);
  }
  50% {
    box-shadow: 0 4px 20px rgba(99, 102, 241, 0.7);
  }
}

/* Dark theme install app link */
body.dark-mode .install-app-link {
  background: linear-gradient(135deg, #818cf8 0%, #6366f1 100%) !important;
  box-shadow: 0 4px 14px rgba(99, 102, 241, 0.5) !important;
}

body.dark-mode .install-app-link:hover {
  background: linear-gradient(135deg, #6366f1 0%, #4f46e5 100%) !important;
  box-shadow: 0 6px 20px rgba(99, 102, 241, 0.8) !important;
}

/* Mobile install app link */
@media (max-width: 991.98px) {
  .install-app-link {
    animation: none !important;
    margin: 0.5rem 0.75rem !important;
  }
  
  /* Mobile instruction icons */
  .instruction-mobile-icon {
    width: 26px !important;
    height: 26px !important;
    display: inline-flex !important;
    align-items: center !important;
    justify-content: center !important;
    border-radius: 6px !important;
    font-size: 14px !important;
    margin-right: 10px !important;
  }
  
  .android-icon {
    background: linear-gradient(135deg, #3ddc84 0%, #00bfa5 100%) !important;
    color: white !important;
  }
  
  .ios-icon {
    background: linear-gradient(135deg, #1a1a1a 0%, #4a4a4a 100%) !important;
    color: white !important;
  }
  
  .desktop-icon {
    background: linear-gradient(135deg, #6366f1 0%, #4f46e5 100%) !important;
    color: white !important;
  }
  
  .push-icon {
    background: linear-gradient(135deg, #ff6b6b 0%, #ee5a24 100%) !important;
    color: white !important;
  }
}

/* Desktop instruction icons */
@media (min-width: 992px) {
  .instruction-mobile-icon {
    width: 32px !important;
    height: 32px !important;
    display: inline-flex !important;
    align-items: center !important;
    justify-content: center !important;
    border-radius: 8px !important;
    font-size: 16px !important;
    margin-right: 12px !important;
  }
  
  .android-icon {
    background: linear-gradient(135deg, #3ddc84 0%, #00bfa5 100%) !important;
    color: white !important;
  }
  
  .ios-icon {
    background: linear-gradient(135deg, #1a1a1a 0%, #4a4a4a 100%) !important;
    color: white !important;
  }
  
  .desktop-icon {
    background: linear-gradient(135deg, #6366f1 0%, #4f46e5 100%) !important;
    color: white !important;
  }
  
  .push-icon {
    background: linear-gradient(135deg, #ff6b6b 0%, #ee5a24 100%) !important;
    color: white !important;
  }
  
  .autoreplace-icon {
    background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%) !important;
    color: white !important;
  }
}

/* ===== INSTRUCTION MODAL STYLES ===== */
.modal-instruction {
  max-width: 600px !important;
}

.modal-header-instruction {
  display: flex !important;
  align-items: center !important;
  padding: 1.5rem !important;
  border-bottom: 1px solid rgba(99, 102, 241, 0.1) !important;
  background: linear-gradient(135deg, rgba(99, 102, 241, 0.05) 0%, rgba(139, 92, 246, 0.05) 100%) !important;
}

.modal-instruction-icon {
  width: 56px !important;
  height: 56px !important;
  border-radius: 16px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  margin-right: 16px !important;
  font-size: 24px !important;
  flex-shrink: 0 !important;
}

.android-bg {
  background: linear-gradient(135deg, #3ddc84 0%, #00bfa5 100%) !important;
  color: white !important;
  box-shadow: 0 8px 25px rgba(61, 220, 132, 0.4) !important;
}

.ios-bg {
  background: linear-gradient(135deg, #1a1a1a 0%, #4a4a4a 100%) !important;
  color: white !important;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.3) !important;
}

.push-bg {
  background: linear-gradient(135deg, #ff6b6b 0%, #ee5a24 100%) !important;
  color: white !important;
  box-shadow: 0 8px 25px rgba(255, 107, 107, 0.4) !important;
}

.modal-title {
  font-size: 1.25rem !important;
  font-weight: 700 !important;
  margin-bottom: 2px !important;
}

.modal-subtitle {
  font-size: 0.875rem !important;
  color: var(--modern-text-muted) !important;
}

.btn-close-instruction {
  position: absolute !important;
  right: 1rem !important;
  top: 1rem !important;
  padding: 0.5rem !important;
  opacity: 0.6 !important;
  transition: all 0.2s ease !important;
}

.btn-close-instruction:hover {
  opacity: 1 !important;
  transform: rotate(90deg) !important;
}

.modal-body-instruction {
  padding: 1.5rem !important;
  max-height: 60vh !important;
  overflow-y: auto !important;
}

.instruction-steps {
  display: flex !important;
  flex-direction: column !important;
  gap: 1rem !important;
}

.instruction-step {
  display: flex !important;
  align-items: flex-start !important;
  padding: 1rem !important;
  background: rgba(99, 102, 241, 0.03) !important;
  border-radius: 12px !important;
  border: 1px solid rgba(99, 102, 241, 0.08) !important;
  transition: all 0.3s ease !important;
}

.instruction-step:hover {
  background: rgba(99, 102, 241, 0.06) !important;
  transform: translateX(4px) !important;
}

.step-number {
  width: 32px !important;
  height: 32px !important;
  min-width: 32px !important;
  border-radius: 50% !important;
  background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%) !important;
  color: white !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  font-weight: 700 !important;
  font-size: 14px !important;
  margin-right: 14px !important;
}

.step-content h6 {
  font-size: 0.95rem !important;
  font-weight: 600 !important;
  margin-bottom: 4px !important;
  color: var(--modern-text-primary) !important;
}

.step-content p {
  font-size: 0.85rem !important;
  color: var(--modern-text-muted) !important;
  margin-bottom: 0 !important;
  line-height: 1.5 !important;
}

.instruction-tips {
  margin-top: 1.25rem !important;
}

.tip-box {
  display: flex !important;
  align-items: flex-start !important;
  gap: 10px !important;
  padding: 12px 16px !important;
  background: rgba(255, 193, 7, 0.1) !important;
  border-radius: 10px !important;
  border: 1px solid rgba(255, 193, 7, 0.2) !important;
}

.tip-box i {
  font-size: 18px !important;
  margin-top: 2px !important;
}

.tip-box span {
  font-size: 0.85rem !important;
  color: var(--modern-text-primary) !important;
  line-height: 1.5 !important;
}

.modal-footer-instruction {
  padding: 1rem 1.5rem !important;
  border-top: 1px solid rgba(99, 102, 241, 0.1) !important;
  justify-content: flex-end !important;
}

/* Push Settings Section */
.push-settings-section {
  margin-top: 1.5rem !important;
  padding: 1.25rem !important;
  background: rgba(99, 102, 241, 0.03) !important;
  border-radius: 12px !important;
  border: 1px solid rgba(99, 102, 241, 0.08) !important;
}

.push-settings-section h6 {
  font-size: 0.95rem !important;
  font-weight: 600 !important;
  margin-bottom: 1rem !important;
  color: var(--modern-text-primary) !important;
}

.settings-grid {
  display: flex !important;
  flex-direction: column !important;
  gap: 0.75rem !important;
}

.settings-item {
  display: flex !important;
  align-items: center !important;
  padding: 0.75rem !important;
  background: rgba(255, 255, 255, 0.5) !important;
  border-radius: 8px !important;
}

body.dark-mode .settings-item {
  background: rgba(0, 0, 0, 0.2) !important;
}

.settings-icon {
  width: 36px !important;
  height: 36px !important;
  border-radius: 8px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  margin-right: 12px !important;
  font-size: 18px !important;
}

.settings-text {
  display: flex !important;
  flex-direction: column !important;
}

.settings-text strong {
  font-size: 0.875rem !important;
  font-weight: 600 !important;
  color: var(--modern-text-primary) !important;
}

.settings-text span {
  font-size: 0.75rem !important;
  color: var(--modern-text-muted) !important;
}

/* Desktop Modal Tabs */
.instruction-tabs {
  display: flex !important;
  gap: 8px !important;
  margin-bottom: 1.25rem !important;
  flex-wrap: wrap !important;
}

.tab-btn {
  display: flex !important;
  align-items: center !important;
  gap: 8px !important;
  padding: 10px 16px !important;
  background: rgba(99, 102, 241, 0.08) !important;
  border: 1px solid rgba(99, 102, 241, 0.15) !important;
  border-radius: 10px !important;
  color: var(--modern-text-primary) !important;
  font-size: 0.875rem !important;
  font-weight: 500 !important;
  cursor: pointer !important;
  transition: all 0.3s ease !important;
}

.tab-btn:hover {
  background: rgba(99, 102, 241, 0.15) !important;
  transform: translateY(-2px) !important;
}

.tab-btn.active {
  background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%) !important;
  color: white !important;
  border-color: transparent !important;
  box-shadow: 0 4px 15px rgba(99, 102, 241, 0.4) !important;
}

.tab-btn i {
  font-size: 16px !important;
}

.tab-content {
  display: none !important;
}

.tab-content.active {
  display: block !important;
  animation: fadeIn 0.3s ease !important;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Desktop modal header */
.desktop-bg {
  background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%) !important;
  color: white !important;
  box-shadow: 0 8px 25px rgba(99, 102, 241, 0.4) !important;
}

/* Dark theme tabs */
body.dark-mode .tab-btn {
  background: rgba(99, 102, 241, 0.12) !important;
  border-color: rgba(99, 102, 241, 0.2) !important;
}

body.dark-mode .tab-btn:hover {
  background: rgba(99, 102, 241, 0.2) !important;
}

/* Dark theme modal */
body.dark-mode .modal-header-instruction {
  background: linear-gradient(135deg, rgba(99, 102, 241, 0.1) 0%, rgba(139, 92, 246, 0.1) 100%) !important;
}

body.dark-mode .modal-subtitle {
  color: #94a3b8 !important;
}

body.dark-mode .instruction-step {
  background: rgba(99, 102, 241, 0.08) !important;
  border-color: rgba(99, 102, 241, 0.15) !important;
}

body.dark-mode .instruction-step:hover {
  background: rgba(99, 102, 241, 0.12) !important;
}

body.dark-mode .tip-box {
  background: rgba(255, 193, 7, 0.15) !important;
  border-color: rgba(255, 193, 7, 0.3) !important;
}

body.dark-mode .push-settings-section {
  background: rgba(99, 102, 241, 0.08) !important;
  border-color: rgba(99, 102, 241, 0.15) !important;
}

/* Mobile modal styles */
@media (max-width: 576px) {
  .modal-instruction {
    margin: 0.5rem !important;
    max-width: calc(100% - 1rem) !important;
  }
  
  .modal-header-instruction {
    padding: 1rem !important;
  }
  
  .modal-instruction-icon {
    width: 44px !important;
    height: 44px !important;
    font-size: 20px !important;
    margin-right: 12px !important;
  }
  
  .modal-title {
    font-size: 1.1rem !important;
  }
  
  .modal-body-instruction {
    padding: 1rem !important;
  }
  
  .instruction-step {
    padding: 0.875rem !important;
  }
  
  .step-number {
    width: 28px !important;
    height: 28px !important;
    min-width: 28px !important;
    font-size: 12px !important;
    margin-right: 10px !important;
  }
  
  .step-content h6 {
    font-size: 0.875rem !important;
  }
  
  .step-content p {
    font-size: 0.8rem !important;
  }
}

/* Autoreplace modal styles */
.autoreplace-bg {
  background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%) !important;
  color: white !important;
  box-shadow: 0 8px 25px rgba(245, 158, 11, 0.4) !important;
}

.copy-script-btn {
  margin-top: 0.75rem !important;
  margin-bottom: 0.5rem !important;
}

.copy-notification {
  display: none !important;
  align-items: center !important;
  gap: 8px !important;
  padding: 10px 14px !important;
  background: rgba(34, 197, 94, 0.15) !important;
  border: 1px solid rgba(34, 197, 94, 0.3) !important;
  border-radius: 8px !important;
  color: #16a34a !important;
  font-size: 0.875rem !important;
  font-weight: 500 !important;
}

.copy-notification.show {
  display: inline-flex !important;
  animation: slideIn 0.3s ease !important;
}

.copy-notification i {
  font-size: 16px !important;
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

body.dark-mode .copy-notification {
  background: rgba(34, 197, 94, 0.2) !important;
  border-color: rgba(34, 197, 94, 0.4) !important;
  color: #4ade80 !important;
}

.step-content code {
  background: rgba(99, 102, 241, 0.1) !important;
  color: #6366f1 !important;
  padding: 2px 6px !important;
  border-radius: 4px !important;
  font-size: 0.85em !important;
}

body.dark-mode .step-content code {
  background: rgba(99, 102, 241, 0.2) !important;
  color: #818cf8 !important;
}
</style>
